function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/* eslint-disable no-useless-escape */
export default {
  props: ['value'],
  computed: {
    model: {
      get: function get() {
        return this.value;
      },
      set: function set(value) {
        this.$emit('input', value);
      }
    },
    bind: function bind() {
      var data = {};
      var isRequired = !!this.rules.map(function (rule) {
        return rule.name;
      }).includes('required');

      if (isRequired && this.$attrs.label) {
        if (this.$attrs.label.slice(-1) !== '*') {
          this.$attrs.label += '*';
        }
      }

      if (this.$attrs.id) data.value = this.$attrs.id;

      if (this.$vnode.data.model) {
        var expression = this.$vnode.data.model.expression;
        var key = expression.replace('form.', 'form-').replaceAll(/(\.|\[|\])/g, '-').replaceAll('--', '-');
        data["class"] = key;
      }

      if (this.searchInput === false) {
        data["class"] = data["class"] ? "".concat(data["class"], " empty") : 'empty';
      }

      return _objectSpread(_objectSpread(_objectSpread({
        filled: true,
        'persistent-hint': true,
        title: this.$attrs.label
      }, this.$props), this.$attrs), data);
    },
    rules: function rules() {
      var _this = this;

      var rules = this.$attrs.rules || [];

      if (this.$attrs.pattern) {
        switch (this.$attrs.pattern) {
          case 'phonenumber':
            this.$attrs.pattern = '^[- s./0-9()+]*$';
            break;

          case 'numbers':
            this.$attrs.pattern = '^[1-9]d*$';
            break;

          case 'no-numbers':
            this.$attrs.pattern = '^([^0-9]*)$';
            break;

          default:
            break;
        }

        var patternRule = function patternRule(value) {
          return !value || RegExp(_this.$attrs.pattern).test(value) || _this.$attrs['pattern-error-message'] || _this.$store.state.forms.labels.ruleFormat;
        };

        rules.push(patternRule);
      }

      if (this.$attrs.type === 'number') {
        var _this$$attrs = this.$attrs,
            min = _this$$attrs.min,
            max = _this$$attrs.max;

        if (max) {
          rules.push(function (value) {
            return !value || Number(value) <= Number(max) || _this.$attrs['pattern-error-message'] || _this.$store.state.forms.labels.ruleFormat;
          });
        }

        if (min) {
          rules.push(function (value) {
            return !value || Number(value) >= Number(min) || _this.$attrs['pattern-error-message'] || _this.$store.state.forms.labels.ruleFormat;
          });
        }
      }

      return this.$attrs.disabled ? [] : rules;
    }
  },
  watch: {
    model: function model(newVal, oldVal) {
      if (!newVal && !!oldVal) {
        this.model = undefined;
        this.destroyModel();
      }
    }
  },
  destroyed: function destroyed() {
    this.destroyModel();
  },
  methods: {
    destroyModel: function destroyModel() {
      if (this.$vnode.data.model) {
        var expression = this.$vnode.data.model.expression;
        var form = this.$store.state.forms.form;
        var key = expression.replace('form.', '');
        delete form[key];
        this.$store.commit('forms/SET_FORM', form);
      }
    }
  }
};